import { render, staticRenderFns } from "./DormProperty.vue?vue&type=template&id=6fe1bc53&scoped=true&"
import script from "./DormProperty.vue?vue&type=script&lang=js&"
export * from "./DormProperty.vue?vue&type=script&lang=js&"
import style0 from "./DormProperty.vue?vue&type=style&index=0&id=6fe1bc53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1bc53",
  null
  
)

component.options.__file = "DormProperty.vue"
export default component.exports